import { api } from "../../../../../../../../../../../services/core-api-service"

class ResetEnvironmentDialogService {
    public async resetEnvironment() {
        return api.demo.resetEnvironment({})
    }
}

export const service = new ResetEnvironmentDialogService()